import { EmployeeGroupWithSchedule, ExtendedEmployee } from '@expane/data'
import { isDateSameDayOrBefore, isWithinInterval } from '@expane/date'

export const getEmployeeGroupsWithEmployeesWithSalarySettings = (
  employeeGroups: EmployeeGroupWithSchedule[] | undefined,
  fromDate: Date,
  toDate: Date,
) => {
  if (!employeeGroups) return []

  const groupsWithEmployeesWithSalarySettings: EmployeeGroupWithSchedule[] = []

  for (const group of employeeGroups) {
    if (group.employees) {
      groupsWithEmployeesWithSalarySettings.push({
        ...group,
        employees: group.employees.filter(
          employee =>
            employee.salarySettings.length &&
            employee.salarySettings.some(
              setting =>
                isWithinInterval(setting.start, {
                  start: fromDate,
                  end: toDate,
                }) || isDateSameDayOrBefore(setting.start, fromDate),
            ),
        ),
      })
    }
  }

  return groupsWithEmployeesWithSalarySettings.filter(group => group.employees.length)
}

export const getEmployeesWithSalarySettings = (employees: ExtendedEmployee[] | undefined) =>
  employees?.filter(employee => employee.salarySettings_aggregate)
